import styled, { css } from 'styled-components';
import { SelectProps } from './Select.types';
import { Select } from 'antd';
import {
  space,
  layout,
  color,
  background,
  border,
  flexbox,
  grid,
  position,
  shadow,
  typography,
  compose,
} from 'styled-system';

export const SelectBase = styled(Select)<SelectProps>(
  (props) =>
    css`
      .ant-select-selector {
        height: ${() => props.height} !important;
        border: ${props?.border ||
        '1px solid rgba(55, 0, 179, 0.12)'} !important;
      }

      .ant-select-selection-item {
        display: flex;
        align-items: center;
        font-size: ${() => (props?.fontSize as string) || '14px'};
      }

      .ant-select-selection-placeholder {
        display: flex;
        align-items: center;
        color: ${() => props.color || '#8f9091'} !important;
      }

      #create-lost-hour-prop_employee {
        height: 100% !important;
      }

      .ant-select-selection-item-content .ant-checkbox {
        display: none;
      }

      .ant-select-selector .ant-select-selection-search-input {
        height: 100%;
      }

      .ant-select-selection-search-input {
        height: 100% !important;
      }
    `,

  ({ borderColor, theme }) =>
    borderColor &&
    css`
      .ant-select-selector {
        height: 54px !important;
        border: ${border} !important;
      }
    `,

  compose(
    space,
    layout,
    color,
    background,
    border,
    flexbox,
    grid,
    position,
    shadow,
    typography
  )
);
